module.exports = __webpack_public_path__ + "img/network_security-1440.b388501c.jpg";